import Util from '../../util.js';

class Card extends HTMLElement {

    static CARD_TYPES = {
        default: 'default',
        flat: 'flat',
        dark: 'dark'
    };

    static get observedAttributes() {
        return ['type', 'show-elevation'];
    }

    #template = document.createElement('template');
    #templateMarkup = `
    <section>
        <slot name="header"></slot>
        <slot name="body"></slot>
        <slot name="footer"></slot>
    </section>
    `;

    constructor() {
        super();
        this.attachShadow({mode: 'open'});
        this.addStyle = Util.addStyle;
        this.addStyle('/src/styles/neptune.css');
        this.addStyle('/src/components/container/card/card.css');
        this.#template.innerHTML = this.#templateMarkup;
        this.shadowRoot.appendChild(this.#template.content.cloneNode(true));
        this.failed = false;
    }

    connectedCallback() {
        if (this.failed) return;
        this.setCard();
    }

    attributeChangedCallback(name, oldValue, newValue) {
        if (this.failed) return;
        if (!this.isConnected) return;
        if (oldValue === newValue) return;
        this.setCard();
    }

    setCard() {
        if (this.failed) return;

        const rawType = (this.getAttribute('type') || '').trim().toLowerCase();
        const rawElevation = (this.getAttribute('show-elevation') || '').trim().toLowerCase();

        if (!rawType || !Object.values(Card.CARD_TYPES).includes(rawType)) {
            this.failed = true;
            if (this.hasAttribute('show-elevation')) this.removeAttribute('show-elevation');
            throw new Error(`Invalid type value "${rawType}" for <neptune-card>. The valid types are: ${Object.values(Card.CARD_TYPES).join(', ')}.`);
        }

        const showElevation = rawElevation === 'true';

        if (this.getAttribute('type') !== rawType) {
            this.setAttribute('type', rawType);
        }

        if (showElevation) {
            if (this.getAttribute('show-elevation') !== 'true') {
                this.setAttribute('show-elevation', 'true');
            }
        } else {
            if (this.hasAttribute('show-elevation')) {
                this.removeAttribute('show-elevation');
            }
        }
    }
}

customElements.define('neptune-card', Card);
export default Card;